import { DICT_KEY, getDictNameByCode, getModel, setModel } from "../../../utils/constants";
import moment from "moment";
import ModelUtils from "../../../utils/ModelUtils";
import PurchaseRoService from "./PurchaseRoService";
import PurchasePoService from "../po/PurchasePoService";

const MODEL_KEY = DICT_KEY.PURCHASE_RO;
const storageModel = getModel(MODEL_KEY);


//转换日期函数
function transRangePickerValue(obj, ...values) {
    if (!!!obj) return;
    let tmp = obj;
    for (let i = 0; i < values.length; i++) {
        if (tmp[values[i]]) {
            tmp = tmp[values[i]]
        } else {
            break;
        }
        if (i === values.length - 1) {
            tmp[0] = moment(tmp[0])
            tmp[1] = moment(tmp[1])
        }
    }
}

transRangePickerValue(storageModel, "searchParam", "startEndDate");

const cacheAble = false;

const initModel = {
    //查询参数
    searchParam: {},
    //单据列表
    documentList: [],
    //销售退货单统计信息
    documentStatistic: {},
    //单据列表分页信息
    documentPageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 15
    },
    //选中单据
    selectedDocument: {},
    //选中单据key数组
    selectedDocumentRowKeys: [],
    //单据打印窗口显示
    printDocumentModelVisible: false,


    //单据配件列表
    documentMaterialList: [],
    //选中配件
    selectedDocumentMaterial: null,
    //选中配件key数组
    selectedDocumentMaterialRowKeys: [],
    //明细统计信息
    detailStatistics: {
        roTotalNum: 0,
        roTotalAmount: 0.00,
        roReceivableAmount: 0.00,
    },

    //添加物料窗口显示
    addMaterialModelVisible: false,
    materialSearchParam: {},
    //待选配件列表
    materialList: [],
    materialPageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 5
    },
    //已选配件列表(废弃)
    selectedMaterialList: [],
    //结算
    paymentDrawerVisible: false,

    formExpand: false,
    formData: {},

};
const purchaseRoModel = {
    state: cacheAble && storageModel ? storageModel : initModel,
    reducers: {
        init(state, ) {
            state = { ...initModel };
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        toggleExpand(state, ) {
            state.formExpand = !state.formExpand;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setFormData(state, payload) {
            state.formData = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setSearchParam(state, payload) {
            state.searchParam = { ...state.searchParam, ...payload };
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        clearSearchParam(state, ) {
            state.searchParam = {};
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setDocumentList(state, payload) {
            state.documentList = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setDocumentStatistic(state, payload) {
            state.documentStatistic = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setDocumentPageInfo(state, payload) {
            state.documentPageInfo = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setSelectedDocument(state, payload) {
            state.selectedDocument = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setSelectedDocumentRowKeys(state, payload) {
            state.selectedDocumentRowKeys = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setPrintDocumentModelVisible(state, payload) {
            state.printDocumentModelVisible = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },

        setDocumentMaterialList(state, payload) {
            state.documentMaterialList = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        //添加单据中的配件信息
        addDocumentMaterial(state, payload) {
            state.documentMaterialList.push(...payload);
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        //移除单据中的配件信息
        removeDocumentMaterial(state, payload) {
            state.documentMaterialList = state.documentMaterialList.filter(el => !!!payload.find(ele => ele === el.key));
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        //设置单据中选中的配件
        setSelectedDocumentMaterial(state, payload) {
            state.selectedDocumentMaterial = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setSelectedDocumentMaterialRowKeys(state, payload) {
            state.selectedDocumentMaterialRowKeys = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },

        setAddMaterialModelVisible(state, payload) {
            state.addMaterialModelVisible = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setMaterialSearchParam(state, payload) {
            state.materialSearchParam = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        //待选配件列表
        setMaterialList(state, payload) {
            state.materialList = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setMaterialPageInfo(state, payload) {
            state.materialPageInfo = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setSelectedMaterialList(state, payload) {
            state.selectedMaterialList = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        //添加已选配件
        addSelectedMaterial(state, payload) {
            // state.materialList = state.materialList.filter(el => el.id !== payload.id);
            state.selectedMaterialList.push(payload);
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        //全选添加
        addSelectedMaterialAll(state, payload) {
            //拿到已选配件的id  
            let selectedId = state.documentMaterialList.map(item => item.porderId);
            //过滤掉已添加配件和 销售数量 大于 退货数量 
            let newSeleedAllList = payload.filter(el => (selectedId.indexOf(el.id) < 0 && el.returnNum < el.purchaseNum));
            state.selectedMaterialList = newSeleedAllList;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        //删除已选配件
        removeSelectedMaterial(state, payload) {
            // state.materialList.push(payload);
            state.selectedMaterialList = state.selectedMaterialList.filter(el => el.id !== payload.id);
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        //设置支付窗口显示
        setPaymentDrawerVisible(state, payload) {
            state.paymentDrawerVisible = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        setDetailStatistics(state, payload) {
            state.detailStatistics = payload;
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        //选中采购明细列表转化为采购退货单明细列表
        transSelectedPoItemListToRoItemList(state, ) {
            const mappedItems = state.selectedMaterialList.map(el => {
                let tmp = poItemTransToRoItem(el);
                const { returnNum, returnPrice, discount, } = tmp
                tmp.returnAmount = (returnNum * returnPrice).toFixed(2);
                tmp.receivableAmount = (returnNum * returnPrice * discount / 100).toFixed(2);
                return tmp;
            })
            state.documentMaterialList = [...state.documentMaterialList, ...mappedItems]
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
        updateStatus(state, status) {
            state.selectedDocument = { ...state.selectedDocument, ...status }
            if (cacheAble) setModel(MODEL_KEY, { ...state });
        },
    },
    effects: () => ({
        //加载单据列表
        async loadDocumentList({ showMsg = true, duration = 5, data }) {
            const funName = "加载采购退货单列表";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PurchaseRoService.findPage(data);
                const { list, statistics, ...page } = retData;
                // list.forEach(el => el.key = el.id);
                const mapList = list.map(el => ({
                    ...el,
                    key: el.id,
                    orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.PURCHASE_RETURN_STATUS, el.orderStatus),
                    paymentStatusName: getDictNameByCode(DICT_KEY.CM_DICT.PURCHASE_RETURN_PAY_STATUS, el.paymentStatus),
                    invoiceTypeName: getDictNameByCode(DICT_KEY.CM_DICT.INVOICE_TYPE, el.invoiceType),
                }))
                // console.log(mapList);
                this.setDocumentList(mapList);
                this.setDocumentStatistic(statistics);
                const { pageNum = 1 } = page;
                this.setDocumentPageInfo({ ...page, pageNum: pageNum === 0 ? 1 : pageNum });
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async loadRo({ showMsg = true, duration = 5, data }) {
            const funName = "加载采购退货单详细信息";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PurchaseRoService.findByIdOrCode(data);
                const { details, ...ro } = retData;
                const mappedList = details.map(el => ({
                    ...el,
                    key: el.id,
                    materialUnitName: getDictNameByCode(DICT_KEY.CM_DICT.MATERIAL_UNIT, el.materialUnit)
                }))
                this.setSelectedDocument({
                    ...ro,
                    orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.PURCHASE_RETURN_STATUS, ro.orderStatus),
                });
                this.setDocumentMaterialList(mappedList);
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },

        //新增订单
        async insert({ showMsg = true, duration = 5, data }) {
            const funName = "新增采购退货单";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PurchaseRoService.insert(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //修改订单
        async update({ showMsg = true, duration = 5, data }) {
            const funName = "修改采购退货单";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PurchaseRoService.update(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },

        //导出退货单
        async exportRo({ showMsg = false, duration = 5, data = { pageSize: 5 } }) {
            const funName = "导出采购退货单";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PurchaseRoService.export(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },


        //作废
        async disable({ showMsg = true, duration = 5, data }) {
            const funName = "采购退货单作废";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PurchaseRoService.disable(data);
                if (retData) {
                    this.updateStatus({
                        orderStatus: "027004",
                        orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.PURCHASE_RETURN_STATUS, "027004")
                    });
                }
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },


        //退货收款
        async settle({ showMsg = false, duration = 5, data = { pageSize: 5 } }) {
            const funName = "采购退货收款";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PurchaseRoService.settle(data);
                if (retData) {
                    // this.updateStatus("027003");
                    this.updateStatus({
                        orderStatus: "027003",
                        orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.PURCHASE_RETURN_STATUS, "027003")
                    });
                }
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },

        //库房确认
        async whConfirm({ showMsg = false, duration = 5, data = { pageSize: 5 } }) {
            const funName = "采购退货库房确认";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PurchaseRoService.whConfirm(data);
                if (retData) {
                    // this.updateStatus("027002");
                    this.updateStatus({
                        orderStatus: "027002",
                        orderStatusName: getDictNameByCode(DICT_KEY.CM_DICT.PURCHASE_RETURN_STATUS, "027002")
                    });
                }
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },

        //下载采购退货明细导入模板
        async downloadDetailTpl({ showMsg = false, duration = 5, data }) {
            const funName = "下载采购明细导入模板";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await PurchaseRoService.downloadDetailTpl(data);
                return retData;
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func)
        },
        //加载采购数据
        async loadPurchaseDetailData({ showMsg = false, duration = 5, data = { pageSize: 5 } }) {
            let retData = await PurchasePoService.findDetailPage(data);
            const { list, statistic, ...pageInfo } = retData;
            const mappedList = list.map(el => ({
                ...el,
                key: el.id,
                materialUnitName: getDictNameByCode(DICT_KEY.CM_DICT.MATERIAL_UNIT, el.materialUnit)
            }));
            this.setMaterialList(mappedList);
            const { pageNum = 1 } = pageInfo;
            this.setMaterialPageInfo({ ...pageInfo, pageNum: pageNum === 0 ? 1 : pageNum });
        },
        //全选销售数据
        async loadPurchaseDetailDataAll({ showMsg = false, duration = 5, data = { pageSize: 5 } }) {
            let retData = await PurchasePoService.findDetailPage(data);
            const { list, statistic, ...pageInfo } = retData;
            const mappedList = list.map(el => ({
                ...el,
                key: el.id,
                materialUnitName: getDictNameByCode(DICT_KEY.CM_DICT.MATERIAL_UNIT, el.materialUnit)
            }));
            this.addSelectedMaterialAll(mappedList);
        }

    })
};
//库存数据转换为采购单明细数据
const poItemTransToRoItem = el => {
    const {
        id,
        purchaseId,
        purchaseCode,
        materialId,
        materialCode,
        materialName,
        replaceNum,
        materialUnit,
        materialUnitName,
        returnNum,
        purchaseNum,
        giftsNum,
        purchasePrice,
        warehouseId,
        warehouseName,
        shelfId,
        shelfCode,
    } = el;

    return {
        key: id,
        id: id,
        porderId: id,
        purchaseId,
        purchaseCode,
        materialId,
        materialCode,
        materialName,
        replaceNum,
        materialUnit,
        materialUnitName,
        retiredNum: returnNum,
        purchaseNum,
        giftsNum,
        returnNum: 1,
        returnPrice: !!purchasePrice ? purchasePrice : 0.00,
        discount: 100,
        returnAmount: 0,
        receivableAmount: 0,

        warehouseId: !!warehouseId ? warehouseId : '空',
        warehouseName: !!warehouseName ? warehouseName : '空',
        shelfId: !!shelfId ? shelfId : '空',
        shelfCode: !!shelfCode ? shelfCode : '空',
        returnDesc: "无",


        // "deleteFlag": 0,
        // "createTime": "2020-08-18 09:58:12",
        // "updateTime": "2020-08-18 10:28:42",
        // "createUser": "业务员",
        // "updateUser": "tester",
    };
}
export default purchaseRoModel;